import {
  Customer,
  CustomerGroup,
  SalesHistory,
  CustomerInvoice,
  CustomerReceivable,

} from '@/types/customer';

// Customer Groups
export const mockCustomerGroups: CustomerGroup[] = [
  {
    id: 'CG001',
    name: 'Khách hàng VIP',
    description: 'Khách hàng có giá trị mua sắm cao',
    discountPercentage: 10,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'CG002',
    name: 'Khách hàng thường',
    description: 'Khách hàng mua sắm thường xuyên',
    discountPercentage: 5,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
  {
    id: 'CG003',
    name: 'Khách hàng mới',
    description: 'Khách hàng lần đầu mua sắm',
    discountPercentage: 0,
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-01-15T08:00:00Z',
  },
];

// Mock Customers
export const mockCustomers: Customer[] = [
  {
    id: 'CUST001',
    code: 'KH001',
    name: 'Nguyễn Văn Anh',
    phone: '0901234567',
    email: 'nva@gmail.com',
    customerType: 'individual',
    address: {
      city: 'Thành phố Hồ Chí Minh',
      district: 'Quận 1',
      details: '123 Nguyễn Huệ, Phường Bến Nghé',
    },
    notes: 'Khách hàng VIP, thường mua số lượng lớn',
    status: 'active',
    createdBy: 'admin',
    createdAt: '2024-01-15T08:00:00Z',
    updatedAt: '2024-03-20T10:30:00Z',
    
    // Detailed info
    gender: 'male',
    birthday: '1985-05-15',
    facebookLink: 'https://facebook.com/nguyenvananh',
    customerGroupId: 'CG001',
    customerGroupName: 'Khách hàng VIP',
    
    // Calculated fields
    totalPurchases: 125000000,
    totalDebt: 15000000,
    lastPurchaseDate: '2024-03-18T14:20:00Z',
    paymentStatus: 'pending',
  },
  {
    id: 'CUST002',
    code: 'KH002',
    name: 'Công ty TNHH ABC',
    phone: '0287654321',
    email: 'contact@abc.com.vn',
    customerType: 'company',
    companyName: 'Công ty TNHH ABC',
    address: {
      city: 'Thành phố Hồ Chí Minh',
      district: 'Quận Bình Thạnh',
      details: '456 Điện Biên Phủ, Phường 25',
    },
    notes: 'Công ty xây dựng, thường đặt hàng theo dự án',
    status: 'active',
    createdBy: 'admin',
    createdAt: '2024-01-20T09:15:00Z',
    updatedAt: '2024-03-22T16:45:00Z',
    
    // Detailed info
    taxCode: '0123456789',
    customerGroupId: 'CG001',
    customerGroupName: 'Khách hàng VIP',
    
    // Calculated fields
    totalPurchases: 350000000,
    totalDebt: 45000000,
    lastPurchaseDate: '2024-03-20T11:30:00Z',
    paymentStatus: 'overdue',
  },
  {
    id: 'CUST003',
    code: 'KH003',
    name: 'Trần Thị Bình',
    phone: '0905678910',
    email: 'ttbinh@yahoo.com',
    customerType: 'individual',
    address: {
      city: 'Hà Nội',
      district: 'Quận Hoàn Kiếm',
      details: '789 Hàng Bài, Phường Hàng Bài',
    },
    notes: 'Khách hàng thân thiết, hay giới thiệu khách mới',
    status: 'active',
    createdBy: 'admin',
    createdAt: '2024-02-01T10:30:00Z',
    updatedAt: '2024-03-19T08:15:00Z',
    
    // Detailed info
    gender: 'female',
    birthday: '1990-12-03',
    facebookLink: 'https://facebook.com/tranthibinh',
    customerGroupId: 'CG002',
    customerGroupName: 'Khách hàng thường',
    
    // Calculated fields
    totalPurchases: 75000000,
    totalDebt: 0,
    lastPurchaseDate: '2024-03-15T13:45:00Z',
    paymentStatus: 'paid',
  },
  {
    id: 'CUST004',
    code: 'KH004',
    name: 'Lê Minh Đức',
    phone: '0909876543',
    email: 'lmduc@hotmail.com',
    customerType: 'individual',
    address: {
      city: 'Đà Nẵng',
      district: 'Quận Hải Châu',
      details: '321 Trần Phú, Phường Thạch Thang',
    },
    notes: 'Khách hàng mới, cần chăm sóc đặc biệt',
    status: 'active',
    createdBy: 'admin',
    createdAt: '2024-03-01T14:20:00Z',
    updatedAt: '2024-03-10T12:00:00Z',
    
    // Detailed info
    gender: 'male',
    birthday: '1988-08-20',
    customerGroupId: 'CG003',
    customerGroupName: 'Khách hàng mới',
    
    // Calculated fields
    totalPurchases: 25000000,
    totalDebt: 5000000,
    lastPurchaseDate: '2024-03-08T10:20:00Z',
    paymentStatus: 'pending',
  },
  {
    id: 'CUST005',
    code: 'KH005',
    name: 'Công ty CP XYZ',
    phone: '0243456789',
    email: 'info@xyz.vn',
    customerType: 'company',
    companyName: 'Công ty CP XYZ',
    address: {
      city: 'Hà Nội',
      district: 'Quận Cầu Giấy',
      details: '654 Nguyễn Trãi, Phường Thanh Xuân',
    },
    notes: 'Công ty nội thất, đối tác lâu năm',
    status: 'inactive',
    createdBy: 'admin',
    createdAt: '2023-12-15T09:00:00Z',
    updatedAt: '2024-02-28T15:30:00Z',
    
    // Detailed info
    taxCode: '9876543210',
    customerGroupId: 'CG002',
    customerGroupName: 'Khách hàng thường',
    
    // Calculated fields
    totalPurchases: 180000000,
    totalDebt: 0,
    lastPurchaseDate: '2024-02-20T16:00:00Z',
    paymentStatus: 'paid',
  },
];

// Mock Sales History
export const mockSalesHistory: SalesHistory[] = [
  {
    id: 'SH001',
    customerId: 'CUST001',
    orderCode: 'DH001',
    date: '2024-03-18T14:20:00Z',
    seller: 'Nguyễn Thu Hà',
    total: 25000000,
    status: 'completed',
    type: 'sale',
    items: [
      {
        id: 'SI001',
        productName: 'Gỗ thông cao cấp',
        quantity: 50,
        unitPrice: 400000,
        totalPrice: 20000000,
        unit: 'm²',
      },
      {
        id: 'SI002',
        productName: 'Mica màu trắng',
        quantity: 10,
        unitPrice: 500000,
        totalPrice: 5000000,
        unit: 'tấm',
      },
    ],
    createdAt: '2024-03-18T14:20:00Z',
    updatedAt: '2024-03-18T14:20:00Z',
  },
  {
    id: 'SH002',
    customerId: 'CUST002',
    orderCode: 'DH002',
    date: '2024-03-20T11:30:00Z',
    seller: 'Trần Văn Nam',
    total: 85000000,
    status: 'completed',
    type: 'sale',
    items: [
      {
        id: 'SI003',
        productName: 'Thép xây dựng',
        quantity: 100,
        unitPrice: 600000,
        totalPrice: 60000000,
        unit: 'kg',
      },
      {
        id: 'SI004',
        productName: 'Xi măng Portland',
        quantity: 50,
        unitPrice: 500000,
        totalPrice: 25000000,
        unit: 'bao',
      },
    ],
    createdAt: '2024-03-20T11:30:00Z',
    updatedAt: '2024-03-20T11:30:00Z',
  },
  {
    id: 'SH003',
    customerId: 'CUST003',
    orderCode: 'TH001',
    date: '2024-03-10T09:15:00Z',
    seller: 'Nguyễn Thu Hà',
    total: 3000000,
    status: 'completed',
    type: 'return',
    items: [
      {
        id: 'SI005',
        productName: 'Gỗ thông cao cấp',
        quantity: 5,
        unitPrice: 400000,
        totalPrice: 2000000,
        unit: 'm²',
      },
      {
        id: 'SI006',
        productName: 'Mica màu xanh',
        quantity: 2,
        unitPrice: 500000,
        totalPrice: 1000000,
        unit: 'tấm',
      },
    ],
    createdAt: '2024-03-10T09:15:00Z',
    updatedAt: '2024-03-10T09:15:00Z',
  },
];

// Mock Customer Invoices
export const mockCustomerInvoices: CustomerInvoice[] = [
  {
    id: 'INV001',
    customerId: 'CUST001',
    invoiceCode: 'HD001',
    time: '2024-03-18T14:20:00Z',
    seller: 'Nguyễn Thu Hà',
    total: 25000000,
    status: 'sent',
    dueDate: '2024-04-18T00:00:00Z',
    paidAmount: 10000000,
    remainingAmount: 15000000,
    items: [
      {
        id: 'II001',
        productName: 'Gỗ thông cao cấp',
        quantity: 50,
        unitPrice: 400000,
        totalPrice: 20000000,
        unit: 'm²',
        taxAmount: 2000000,
      },
      {
        id: 'II002',
        productName: 'Mica màu trắng',
        quantity: 10,
        unitPrice: 500000,
        totalPrice: 5000000,
        unit: 'tấm',
        taxAmount: 500000,
      },
    ],
    createdAt: '2024-03-18T14:20:00Z',
    updatedAt: '2024-03-19T10:30:00Z',
  },
  {
    id: 'INV002',
    customerId: 'CUST002',
    invoiceCode: 'HD002',
    time: '2024-03-20T11:30:00Z',
    seller: 'Trần Văn Nam',
    total: 85000000,
    status: 'overdue',
    dueDate: '2024-03-25T00:00:00Z',
    paidAmount: 40000000,
    remainingAmount: 45000000,
    items: [
      {
        id: 'II003',
        productName: 'Thép xây dựng',
        quantity: 100,
        unitPrice: 600000,
        totalPrice: 60000000,
        unit: 'kg',
        taxAmount: 6000000,
      },
      {
        id: 'II004',
        productName: 'Xi măng Portland',
        quantity: 50,
        unitPrice: 500000,
        totalPrice: 25000000,
        unit: 'bao',
        taxAmount: 2500000,
      },
    ],
    createdAt: '2024-03-20T11:30:00Z',
    updatedAt: '2024-03-22T08:15:00Z',
  },
  {
    id: 'INV003',
    customerId: 'CUST003',
    invoiceCode: 'HD003',
    time: '2024-03-15T13:45:00Z',
    seller: 'Nguyễn Thu Hà',
    total: 15000000,
    status: 'paid',
    dueDate: '2024-04-15T00:00:00Z',
    paidAmount: 15000000,
    remainingAmount: 0,
    items: [
      {
        id: 'II005',
        productName: 'Gỗ sồi cao cấp',
        quantity: 20,
        unitPrice: 750000,
        totalPrice: 15000000,
        unit: 'm²',
        taxAmount: 1500000,
      },
    ],
    createdAt: '2024-03-15T13:45:00Z',
    updatedAt: '2024-03-16T09:20:00Z',
  },
];

// Mock Customer Receivables
export const mockCustomerReceivables: CustomerReceivable[] = [
  {
    id: 'REC001',
    customerId: 'CUST001',
    invoiceId: 'INV001',
    invoiceCode: 'HD001',
    date: '2024-03-18T14:20:00Z',
    type: 'invoice',
    amount: 15000000,
    expectedPaymentDate: '2024-04-18T00:00:00Z',
    status: 'pending',
    notes: 'Khách hàng cam kết thanh toán đúng hạn',
    createdAt: '2024-03-18T14:20:00Z',
    updatedAt: '2024-03-19T10:30:00Z',
  },
  {
    id: 'REC002',
    customerId: 'CUST002',
    invoiceId: 'INV002',
    invoiceCode: 'HD002',
    date: '2024-03-20T11:30:00Z',
    type: 'invoice',
    amount: 45000000,
    expectedPaymentDate: '2024-03-25T00:00:00Z',
    status: 'overdue',
    notes: 'Đã quá hạn thanh toán, cần liên hệ khách hàng',
    createdAt: '2024-03-20T11:30:00Z',
    updatedAt: '2024-03-26T14:20:00Z',
  },
  {
    id: 'REC003',
    customerId: 'CUST004',
    invoiceId: 'INV004',
    invoiceCode: 'HD004',
    date: '2024-03-08T10:20:00Z',
    type: 'service',
    amount: 5000000,
    expectedPaymentDate: '2024-04-08T00:00:00Z',
    status: 'pending',
    notes: 'Dịch vụ lắp đặt và bảo hành',
    createdAt: '2024-03-08T10:20:00Z',
    updatedAt: '2024-03-08T10:20:00Z',
  },
];

// Helper functions for generating additional mock data
export const generateCustomerCode = (): string => {
  const nextNumber = mockCustomers.length + 1;
  return `KH${String(nextNumber).padStart(3, '0')}`;
};

export const generateInvoiceCode = (): string => {
  const nextNumber = mockCustomerInvoices.length + 1;
  return `HD${String(nextNumber).padStart(3, '0')}`;
};

export const generateOrderCode = (): string => {
  const nextNumber = mockSalesHistory.length + 1;
  return `DH${String(nextNumber).padStart(3, '0')}`;
};

// Mock data for provinces and cities (simplified)
export const mockProvinces = [
  'Thành phố Hồ Chí Minh',
  'Hà Nội',
  'Đà Nẵng',
  'Hải Phòng',
  'Cần Thơ',
  'Bình Dương',
  'Đồng Nai',
  'Khánh Hòa',
  'Lâm Đồng',
  'Nghệ An',
];

export const mockCities = {
  'Thành phố Hồ Chí Minh': [
    'Quận 1', 'Quận 2', 'Quận 3', 'Quận 4', 'Quận 5',
    'Quận 6', 'Quận 7', 'Quận 8', 'Quận 9', 'Quận 10',
    'Quận 11', 'Quận 12', 'Quận Bình Thạnh', 'Quận Gò Vấp',
    'Quận Phú Nhuận', 'Quận Tân Bình', 'Quận Tân Phú',
    'Quận Thủ Đức', 'Huyện Bình Chánh', 'Huyện Cần Giờ',
    'Huyện Củ Chi', 'Huyện Hóc Môn', 'Huyện Nhà Bè',
  ],
  'Hà Nội': [
    'Quận Ba Đình', 'Quận Hoàn Kiếm', 'Quận Hai Bà Trưng',
    'Quận Đống Đa', 'Quận Tây Hồ', 'Quận Cầu Giấy',
    'Quận Thanh Xuân', 'Quận Hoàng Mai', 'Quận Long Biên',
    'Quận Nam Từ Liêm', 'Quận Bắc Từ Liêm', 'Quận Hà Đông',
  ],
  'Đà Nẵng': [
    'Quận Hải Châu', 'Quận Thanh Khê', 'Quận Sơn Trà',
    'Quận Ngũ Hành Sơn', 'Quận Liên Chiểu', 'Quận Cẩm Lệ',
    'Huyện Hòa Vang', 'Huyện Hoàng Sa',
  ],
};

// Mock sellers/employees
export const mockSellers = [
  'Nguyễn Thu Hà',
  'Trần Văn Nam', 
  'Lê Thị Minh',
  'Phạm Hoàng Long',
  'Vũ Thị Lan',
  'Đỗ Minh Tuấn',
  'Ngô Thị Hương',
  'Bùi Văn Đức',
]; 